import React, { Component } from 'react';
import { Navbar } from 'react-bootstrap';
import { Jumbotron, Button, Modal } from 'react-bootstrap';
import { Grid, Row, Col } from 'react-bootstrap';
import SignIn from './SignIn';

class SplashPage extends Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.state = {
      showLogin: false
    }
  }

  close() {
    this.setState({ showLogin: false });
  }

  open() {
    this.setState({ showLogin: true });
  }

  render() {
    const jumboStyle = {
      marginTop: "-20px"
    }
    return(
      <div>
        <Navbar inverse fixedTop>
          <Navbar.Header>
            <Navbar.Brand>
              <a href="#">Build the Mountain</a>
            </Navbar.Brand>
          </Navbar.Header>
        </Navbar>
        <Jumbotron style={jumboStyle}>
          <div className="container">
            <h1>Build the Mountain</h1>
            <p>A workout tracker where every pound counts.</p>
            <Button bsStyle="primary" bsSize="large" onClick={this.open}>Log In</Button>
          </div>
        </Jumbotron>
        <div className="container">
        <Grid>
          <Row>
            <Col md={4}>
              <h2>About</h2>
              <p>
                Build the Mountain emphasises workout totals over exercise maximums. Whether you Deadlift 400 lbs x 2 reps or 100 lbs x 8 reps your total is the same. Strive to lift heavier but don't sweat a plateau. Energy was burned, you're healthier for it.
              </p>
            </Col>
            <Col md={4}>
              <h2>Bugs</h2>
              <p>
                I'm tracking every pound I lift in 2017. Join me, build your mountain, and help beta test the app. Please forgive the bugs. Build the Mountain is just a baby. If you find any, send me an email (hunter@buildthemountain.com) and I'll happily fix it. 
              </p>
            </Col>
            <Col md={4}>
              <h2>How To</h2>
              <p>
                A more in-depth explanation of how to use the app is on my to-do list but in a nutshell: 
              </p>
                <ol>
                  <li>Start tracking your workouts.</li>
                  <li>Find a total that <i>just</i> pushes your boundaries.</li>
                  <li>Try to beat it every time.</li>
                </ol>
            </Col>
          </Row>
        </Grid>
        <Modal show={this.state.showLogin} onHide={this.close}>
          <Modal.Body>
            <SignIn authenticate={this.props.authenticate} />
          </Modal.Body>
        </Modal>
        </div>
      </div>
    );
  }
}

SplashPage.propTypes = {
  authenticate: React.PropTypes.func.isRequired
}

export default SplashPage;


// WEBPACK FOOTER //
// ./src/components/SplashPage.jsx